import { GameGridObserver } from '@pp/core';

import { GameStore } from '../../store/GameStore';
import { DimensionsType, mwGameGridActions } from '../../store/slices/mwGameGrid/slice';

export const MWGameGridObserver = new GameGridObserver<DimensionsType>((newDimensions) =>
  GameStore.dispatch(mwGameGridActions.setDimensions(newDimensions))
);
